import { useEffect } from 'react';
import smoothScrollIntoView from 'scroll-into-view-if-needed';


/**
 *
 * @param {*} errors
 * @description errors should have ref property and name property inside ref attribute.
 */
export function useScrollToError(errors) {
  useEffect(() => {
    if (errors) {
      const selectorKey = Object.keys(errors)[0];
      const element = errors[selectorKey];
      if (element && element.ref && element.ref.name) {
        const errorElement = document.querySelector(`[name="${element.ref.name}"]`);
        if (errorElement && errorElement.style.display !== 'none') {
          smoothScrollIntoView(errorElement, { scrollMode: 'if-needed', behavior: "smooth" });
        } else if (errorElement) {
          // only one level up check is done here for custom components such as react-dropzone which hides the input
          smoothScrollIntoView(errorElement.parentElement, { scrollMode: 'if-needed', behavior: "smooth" });
        }
      }
    }
  }, [errors]);
}
